/** Public tuition subjects; independent of the E-Math/A-Math enrolment contract. */
export { TUITION_SUBJECT_IDS, type TuitionSubject } from './catalog.js';
import type { TuitionSubject } from './catalog.js';

export const TUITION_SUBJECTS = {
  mathematics: {
    label: 'Mathematics',
    trial: 'free trial class',
    primaryCta: 'Book a Free Trial',
    compactCta: 'Book Free Trial',
    publicDemo: true,
  },
  english: {
    label: 'English',
    trial: 'trial class',
    primaryCta: 'Book a Trial Class',
    compactCta: 'Book a Trial Class',
    publicDemo: false,
  },
  chemistry: {
    label: 'Chemistry',
    trial: 'trial class',
    primaryCta: 'Book a Trial Class',
    compactCta: 'Book a Trial Class',
    publicDemo: false,
  },
} as const satisfies Record<
  TuitionSubject,
  {
    label: string;
    trial: string;
    primaryCta: string;
    compactCta: string;
    publicDemo: boolean;
  }
>;
